function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classnames from 'classnames';
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
import { getHasObjectProperty } from "../../../../utils/get-has-object-property";
export var adaptOptions = function adaptOptions(options, hasImages) {
  if (hasImages) {
    return options.map(function (_ref, index) {
      var imageSizes = _ref.imageSizes,
          imageUrl = _ref.imageUrl,
          imageSrcSet = _ref.imageSrcSet,
          label = _ref.label,
          text = _ref.text,
          value = _ref.value;
      return {
        text: [React.createElement("img", {
          alt: text,
          className: "ui image",
          key: buildKeyFromStrings("img".concat(text), index),
          sizes: imageSizes,
          src: imageUrl,
          srcSet: imageSrcSet
        }), React.createElement("span", {
          className: "text",
          key: buildKeyFromStrings("spa".concat(text), index)
        }, text)],
        key: buildKeyFromStrings(label, index),
        label: label,
        value: value
      };
    });
  }

  if (getHasObjectProperty(options, 'indent')) {
    return options.map(function (_ref2, index) {
      var indent = _ref2.indent,
          label = _ref2.label,
          otherProps = _objectWithoutProperties(_ref2, ["indent", "label"]);

      return _objectSpread({
        className: classnames(_defineProperty({}, "indent-".concat(indent), indent)),
        key: buildKeyFromStrings(label, index),
        label: label
      }, otherProps);
    });
  }

  if (getHasObjectProperty(options, 'label')) {
    return options.map(function (_ref3, index) {
      var label = _ref3.label,
          text = _ref3.text,
          otherProps = _objectWithoutProperties(_ref3, ["label", "text"]);

      return _objectSpread({
        className: classnames({
          'has-label': true
        }),
        key: buildKeyFromStrings(label, index),
        label: label,
        text: text
      }, otherProps);
    });
  }

  return options.map(function (_ref4, index) {
    var label = _ref4.label,
        otherProps = _objectWithoutProperties(_ref4, ["label"]);

    return _objectSpread({
      key: buildKeyFromStrings(label, index),
      label: label
    }, otherProps);
  });
};